import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, combineLatest, filter, map, shareReplay } from 'rxjs';
import { Settings } from 'server/shared/collections/settings';
import { SettingsModel } from 'server/shared/models/settingsModel';
import { SubscriptionService } from '../shared/subscription.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsService implements OnDestroy {
  settings$ = new BehaviorSubject<SettingsModel | undefined>(undefined);
  readySettings$ = this.settings$.pipe(
    filter((settings): settings is SettingsModel => !!settings),
    shareReplay(1),
  );

  potentialInviteeCountsEnabled$ = this.settings$.pipe(
    map((settings) => settings?.enablePotentialInviteeCounts ?? false),
    shareReplay(1),
  );

  private settingsTracker?: Tracker.Computation;

  constructor(private subscriptionService: SubscriptionService) {
    combineLatest([this.subscriptionService.settings.ready$]).subscribe(
      ([_]) => {
        if (this.settingsTracker) {
          this.settingsTracker.stop();
        }
        this.settingsTracker = Tracker.autorun(() => {
          let settings = Settings.findOne();
          this.settings$.next(settings || undefined);
        });
      },
    );
  }

  ngOnDestroy() {
    if (this.settingsTracker) {
      this.settingsTracker.stop();
    }
  }
}
